import { render, staticRenderFns } from "./PurchaseInvoices.vue?vue&type=template&id=477bed71&scoped=true"
import script from "./PurchaseInvoices.vue?vue&type=script&lang=js"
export * from "./PurchaseInvoices.vue?vue&type=script&lang=js"
import style0 from "./PurchaseInvoices.vue?vue&type=style&index=0&id=477bed71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477bed71",
  null
  
)

export default component.exports